import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TripType } from '@constants/home.constants';
import { PassengerTypeCode } from '@models/booking.models';
import { SearchRequest } from '@models/requests/search-request.model';
import { Station } from '@models/responses/station-response.model';

@Injectable({
  providedIn: 'root',
})
export class DohopService {
  private static readonly REQUEST_ROOT = 'https://connections.flynorse.com/';

  getDohopUrl(
    request: SearchRequest,
    tripType: TripType,
    currency: string,
    language: string,
    stations: Station[],
  ): string {
    let params = new HttpParams()
      .set('utm_source', 'norse_picker')
      .set('currency', currency)
      .set('isOneWay', tripType === TripType.oneWay);

    if (request.criteria[0]) {
      /* eslint-disable @typescript-eslint/no-non-null-assertion */
      const originStation = stations.find(
        (s) => s.stationCode === request.criteria[0]!.origin,
      );
      const destinationStation = stations.find(
        (s) => s.stationCode === request.criteria[0]!.destination,
      );
      /* eslint-enable @typescript-eslint/no-non-null-assertion */

      if (originStation && destinationStation) {
        params = params
          .set(
            'origins',
            originStation.macStationCodes
              ? originStation.macStationCodes.join(',')
              : originStation.stationCode,
          )
          .set(
            'destinations',
            destinationStation.macStationCodes
              ? destinationStation.macStationCodes.join(',')
              : destinationStation.stationCode,
          );

        if (request.criteria[0].beginDate) {
          params = params.set('departureDate', request.criteria[0].beginDate);
        }
      }
    }

    if (request.criteria[1]) {
      params = params.set('returnDate', request.criteria[1]?.beginDate);
    }

    const adultCount = request.passengers.find(
      (p) => p.type === PassengerTypeCode.ADT,
    )?.count;
    if (adultCount) {
      const ages: number[] = [];
      for (let i = 0; i < adultCount; i++) {
        ages.push(18);
      }
      params = params.set('adult', ages.toString());
    }
    const childCount = request.passengers.find(
      (p) => p.type === PassengerTypeCode.CHD,
    )?.count;
    if (childCount) {
      const ages: number[] = [];
      for (let i = 0; i < childCount; i++) {
        ages.push(8);
      }
      params = params.set('child', ages.toString());
    }
    const infantCount = request.passengers.find(
      (p) => p.type === PassengerTypeCode.INF,
    )?.count;
    if (infantCount) {
      const ages: number[] = [];
      for (let i = 0; i < infantCount; i++) {
        ages.push(0);
      }
      params = params.set('infant', ages.toString());
    }

    // Map to Do
    switch (language) {
      case 'nb':
        language = 'no';
        break;
      default:
        break;
    }

    return `${
      DohopService.REQUEST_ROOT
    }${language}/search?${params.toString()}`;
  }
}
